const Article = ({ children }) => {
  return <article className={'flex flex-col gap-8 lg:gap-12'}>{children}</article>;
};

export default Article;
